<i18n>
{
  "en": {
    "loading": "Loading..."
  },
  "es": {
    "loading": "Cargando..."
  }
}
</i18n>

<template>
  <div>
    <v-container v-if="container">
      <div v-for="n in numberOfSkeletons" :key="n">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-skeleton-loader v-bind="skeleton.props" :type="skeleton.type"/>
            </div>
          </template>
          <span>{{$t('loading')}}</span>
        </v-tooltip>
      </div>
    </v-container>
    <div v-else>
      <div v-for="n in numberOfSkeletons" :key="n">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-skeleton-loader v-bind="skeleton.props" :type="skeleton.type"/>
            </div>
          </template>
          <span>{{$t('loading')}}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SKELETONS } from '@dynameat/models/skeletons';

@Component
export default class DynameatSkeleton extends Vue {
  @Prop({ type: String, default: 'default', required: true }) skeletonType;

  @Prop({ type: Boolean, default: false }) container;

  get screenHeight() {
    return window.innerHeight;
  }

  get skeleton() {
    return SKELETONS.get(this.skeletonType);
  }

  get numberOfSkeletons() {
    return this.skeleton.numberOfSkeletons(this.screenHeight);
  }
}
</script>
